import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CustomerPromotion } from '../_models/customerpromotion';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getCustomerPromotion() {
    return this.http.get<CustomerPromotion | null>(this.baseUrl + 'customerpromotion');
  }

}
